import moment from 'moment';

export const formatDate = dateString => {
  const date = moment(new Date(dateString));
  return date.format('M/D/YYYY');
};
